import {useState} from "react";

import Box  from "@mui/material/Box";

import Button  from "@mui/material/Button";
import Menu  from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from '@mui/material/Divider';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';


import {   Link as RouterLink  } from "react-router-dom"
  


const SimpleMenu = ({menu})=>{
    return (

        <Button sx={{
                mx:1,
                color:'white',
                display :{
                    
                    },
                }} 
                component={RouterLink} to={menu.path}>
                {menu.name}
        </Button>
        
    )
}

const DropDownMenu = ({menu})=>{

    //const [open, setOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
      };
    
      
      const handleCloseMenu = () => {
        setAnchorEl(null);
      };
    

    return (

        <Box sx={{display:{md:'block', sm:`${menu.large? 'none':'block'}`}}}>
            <Button sx={{color:'white', mx:1,}} onClick={handleOpenMenu}>
                {menu.icon && menu.icon}
                {menu.name} {!Boolean(anchorEl) && <ArrowDropDownIcon/>}
                {Boolean(anchorEl) && <ArrowRightIcon/>}

            </Button>
            <Menu        
                MenuListProps={{ onMouseLeave: handleCloseMenu }}
                keepMounted={true}
                anchorEl={anchorEl}
                //getContentAnchorEl={null}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}    
                
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                //onMouseLeave={()=>{alert(123);handleCloseMenu()}}
                >
                    {menu.sub.map((m, i)=>
                        (
                            Boolean(m.divider) ?  <Divider key={m.id}/> 
                           :
                            <MenuItem onClick={handleCloseMenu} key={m.id} 
                                component={RouterLink} to={m.path?m.path:''} state={{menuname:'kelvin_how_hong'}}>
                                <ListItemText primary={m.name}></ListItemText>
      
                            </MenuItem>
                        )
                    )

            }
            </Menu>
        
        </Box>
    )

}

const AppBarMenu = ({menu})=>{
    let content = Boolean(menu) ? 
    (   
        (menu.sub && menu.sub.length>0) ? <DropDownMenu menu={menu}/>: <SimpleMenu menu={menu}/>

    ) :null;
    return  content

}

export default AppBarMenu;